// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/agents/manager/page"
import { usePageHead } from "../../../compat/head"

export const Route = createFileRoute("/agents/manager/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Nhat ky Manager Agent" })
  return <Page />
}
